<template>
  <div class="flex flex-col bg-block shadow-primaryBlock rounded
                  p-8 lg:px-12 lg:py-13 ">
    <div class="text-xl font-bold text-text leading-tight mb-11">{{ $t('navTitle') }}</div>
    <div v-if="spaces.length === 1"
         class="text-xl font-bold text-text leading-tight mb-17 lg:mb-13">
      {{ current_space.data.title }}
    </div>
    <BaseSelect v-else v-model="selectedSpace"
                :options="spaces"
                label="title"
                class="mb-17 lg:mb-13"
                :allow-empty="false"
                :searchable="false"
                :show-labels="false"/>
    <div v-for="(group,i) in settings_routes_groups.filter(item=>!item.hidden)" :key="i" class="mb-6">
      <div class="flex items-center mb-4-5">
        <component :is="`icon-${group.icon}`" class="text-icon mr-4"/>
        <div class="text-md font-bold text-text leading-tight">{{ group.groupName }}</div>
      </div>
      <router-link v-for="(route,j) in group.routes.filter(item=>!item.hidden)" :key="j"
                   :to="{name:route.name}"
                   class="ml-10 text-sm mb-4 block
                          transition duration-200
                          leading-tighter text-text-secondary hover:text-red"
                   exact-active-class="text-red">
        {{ route.title }}
      </router-link>
    </div>
    <template v-if="!currentUserIsWatcher">
      <SpaceImport class="mb-4 mt-auto"/>
      <SpaceExportTransactions class="mb-4"/>
    </template>
    <SpaceSettingsCreateBtn/>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import IconWallet from "@/components/icons/IconWallet";
import IconCase from "@/components/icons/IconCase";
import IconBox from "@/components/icons/IconBox";
import BaseButton from "@/components/UI/BaseButton";
import IconAddSpace from "@/components/icons/IconAddSpace";
import SpaceSettingsCreateBtn from "@/components/cabinet/SpaceSettings/SpaceSettingsCreateBtn";
import SpaceExportTransactions from "@/components/cabinet/SpaceSettings/SpaceExportTransactions";
import SpaceImport from "@/components/cabinet/SpaceSettings/SpaceImport/SpaceImport";

export default {
  name: "SpaceSettingsNav",
  components: {
    SpaceImport,
    SpaceExportTransactions,
    SpaceSettingsCreateBtn, IconAddSpace, BaseButton, IconWallet, IconCase, IconBox, BaseSelect
  },
  computed: {
    ...mapState('cabinet/user', ['user_info']),
    ...mapState('space', ['current_space', 'spaces']),
    ...mapGetters('space', ['spacesList', 'currentUserIsWatcher']),
    ...mapState('auth', ['user']),
    settings_routes_groups() {
      return [
        {
          groupName: this.$t('finances'),
          icon: 'wallet',
          routes: [
            {name: 'settings-space', title: this.$t('mainSettings')},
            {name: 'settings-accounts', title: this.$t('accounts')},
            {name: 'banks-integrations', title: this.$t('banksIntegration'), hidden: true},
            {name: 'settings-income', title: this.$t('incomes')},
            {name: 'settings-expense', title: this.$t('expenses')},
            {name: 'settings-calendar', title: this.$t('scheduledOperations')},
            {
              name: 'settings-contractors',
              title: this.$t('agents'),
              hidden: !this.current_space.data.contractors_enabled
            },
            {name: 'settings-tags', title: this.$t('tags')},
          ]
        },
        {
          groupName: this.$t('investments'),
          icon: 'case',
          routes: [
            {name: 'invest-profile', title: this.$t('portfolios')},
            // {name: 'settings-accounts', title: 'Счета'},
          ]
        },
        {
          groupName: this.$t('more'),
          icon: 'box',
          routes: [
            {name: 'settings-access', title: this.$t('collaborators'), hidden: this.current_space.data.type === 1},
            {name: 'trash', title: this.$t('trash')},
            {name: 'export-space', title: this.$t('exportTransactions'), hidden: true},
            {name: '', title: this.$t('importTransactions'), hidden: true},
          ]
        },
      ]
    },
    selectedSpace: {
      get() {
        return this.spaces.filter(i => i.id === this.current_space.data.id);
      },
      set(space) {
        const {id: space_id} = space
        this.setUserPrimarySpaceId(space_id);
      }
    },
  },
  methods: {
    ...mapActions('cabinet/user', ['setUserPrimarySpaceId']),
  },
  i18n: {
    messages: {
      en: {
        navTitle: 'Workspace settings',
        finances: 'Finances',
        mainSettings: 'Settings',
        accounts: 'Accounts',
        banksIntegration: 'Banks integrations',
        incomes: 'Income sources',
        expenses: 'Expense categories',
        scheduledOperations: 'Scheduled operations',
        agents: 'Contractors',
        tags: 'Tags',
        investments: 'Investments',
        portfolios: 'Investment portfolios',
        more: 'More',
        collaborators: 'Collaborators',
        exportTransactions: 'Data export',
        importTransactions: 'Data import',
        trash: 'Trash'
      },
      ru: {
        navTitle: 'Настройки пространства',
        finances: 'Финансы',
        mainSettings: 'Настройки',
        accounts: 'Счета',
        banksIntegration: 'Интеграции с банками',
        incomes: 'Источники доходов',
        expenses: 'Категории расходов',
        scheduledOperations: 'Запланированные операции',
        agents: 'Контрагенты',
        tags: 'Теги',
        investments: 'Инвестиции',
        portfolios: 'Инвестпортфели',
        more: 'Дополнительно',
        collaborators: 'Участники',
        exportTransactions: 'Экспорт данных',
        importTransactions: 'Импорт данных',
        trash: 'Корзина'
      }
    }
  }
}
</script>